import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {Apollo} from 'apollo-angular';
import {NotificationService} from 'src/app/services/notification.service';
import {ResponseCodeService} from 'src/app/services/response-code.service';
import {AppState} from 'src/app/store/reducers';
import {map, switchMap} from 'rxjs';

import * as fromGraphql from './service-branch-office.graphql'
import * as fromActions from './service-branch-office.actions'


@Injectable()
export class ServiceBranchOfficeEffects {

  getAllOfficeBranch$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.getAllOfficeBranch),
    switchMap((action) => {
      return this.apollo.query({
        query: fromGraphql.GET_ALL_OFFICE_BRANCH,
        fetchPolicy: 'network-only',
        variables: {
          filtering: action.filtering
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while fetching services'),
        map(({ data }: any ) => {
          if (data) {
            const result: any = Object.values(data)[0]
            result?.response?.status ? this.store.dispatch(fromActions.loadServiceBranchOffices({ serviceBranchOffices: result?.data })) : []
          }
        })
      );
    })
  ), { dispatch: false });
  assignServiceToOfficeBranchMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.assignServiceToOfficeBranchMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.ASSIGN_SERVICE_TO_OFFICE_BRANCH_MUTATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {
              this.store.dispatch(fromActions.upsertServiceBranchOffices({ serviceBranchOffices: result?.data?.officeBranches }));
              this.notificationService.successMessage('Assigned Office Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });

  removeServiceFromOfficeBranchMutation$ = createEffect(() => this.actions$.pipe(
    ofType(fromActions.removeServiceFromOfficeBranchMutation),
    switchMap((action) => {
      return this.apollo.mutate({
        mutation: fromGraphql.REMOVE_SERVICE_FROM_OFFICE_BRANCH_MUTATION,
        variables: {
          input: action?.input,
        }
      }).pipe(
        this.notificationService.catchError('Problem occurred while updating record'),
        map(({ data }: any) => {
          if (data) {
            const result: any = Object.values(data)[0];
            if (result?.response?.code == '9000') {

              this.store.dispatch(fromActions.deleteServiceBranchOffice({ id:action.id+'' }));
              this.notificationService.successMessage('Service Removed From Branch Office Successfully ');
            } else {
              this.notificationService.errorMessage(result?.response?.message + ' code:' + result?.response?.code);
            }
          }
        })
      );
    })
  ), { dispatch: false });





  constructor(
    private actions$: Actions,
    private apollo: Apollo,
    private store: Store<AppState>,
    private notificationService: NotificationService,
    private responseCodesService: ResponseCodeService) {}
}
